<template>
  <div>
    <!-- <div class="text" @click="snackbar = true">trigger snackbar</div> -->
    <v-snackbar v-model="snackbar" bottom :timeout="timeout" class="generic-snackbar">
      {{ message }}
      <v-btn color="primary" flat @click="snackbar = false" :style="buttonFieldDisplay">
        {{ closeButtonText }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "SnackBar",
  components: {},
  props: {
    timeout: Number,
    message: String,
    isSnackbarEnabled: Boolean,
    closeButtonText: String,
    buttonFieldDisplay: Object,
  },
  methods: {},
  data() {
    return {
      snackbar: this.isSnackbarEnabled,
    };
  },
};
</script>

<style lang="scss">
.generic-snackbar {
  & {
    bottom: 40px;
  }
  .v-btn {
    .v-btn__content {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 14px;
    }
  }
  .v-snack__wrapper {
    min-width: 538px;
    background: #f7fdfe;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.14);
    border-radius: 4px;
    height: 57px;
  }
  .v-snack__content {
    font-weight: normal;
    font-size: 16px;
    color: #666666;
    height: auto;
    padding: 12px 24px;
  }
}
</style>
